import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types';
import { CurrentUserInfo } from '@adornis/users/db/currentUserInfo';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { DateTime } from 'luxon';

@Entity()
export class Comment extends MongoEntity {
  static override _class = 'Comment';
  static override _collectionName = 'comments';

  @validate(nonOptional())
  @Field(type => String)
  text!: string;

  // to reply on another comment, just reference the comment as relatedEntityID
  @validate(nonOptional())
  @Field(type => String)
  relatedEntityID!: string;

  @validate(nonOptional())
  @Field(type => DateTime, { default: v => v ?? DateTime.now() })
  createdAt!: DateTime;

  @validate(nonOptional())
  @Field(type => String, { default: v => v ?? 'invalid' })
  createdBy!: string;

  @Field(type => DateTime)
  updatedAt?: DateTime;

  constructor(data: PartialEntityData<Comment>) {
    super(data);
  }

  static override async beforeCreate(entity: Comment): Promise<void> {
    super.beforeCreate(entity);
    entity.createdAt = DateTime.now();
    const userID = (await CurrentUserInfo.getCurrentUserInfo()({ userID: 1 })).userID;
    if (!userID) throw new Error("no user on CurrentUserInfo is set. Draft can't be generated");
    entity.createdBy = userID;
  }

  static override async beforeUpdate(oldEntity: PartialEntityData<Comment>, update: Comment): Promise<void> {
    update.updatedAt = DateTime.now();
    update.text = 'What?';
  }
}
